import { Box, Button, TextField, Typography, Paper, Card, CardContent } from '@mui/material';
import React from 'react';
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import LoadingScreen from './Loading';
import { useState } from 'react';
import { getData } from './features/slices';
import CopyButton from './CoppyComponent'

function Option2() {
  const dispatch = useDispatch()
  const data = useSelector((state) => state.user.data);
  const isLoading = useSelector((state) => state.user.isLoading);
  const [urls, setUrls] = useState()

  const handleClick = async () => {
    await dispatch(getData({ urls }))
    console.log(data)
  }
  return (
    <Box sx={{ width: '100%' }}>
      <NotificationContainer />
      
      <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
          Convert Images
        </Typography>
        <TextField
          label="Nhập URL hình ảnh (cách nhau bằng dấu phẩy)"
          fullWidth
          value={urls}
          onChange={(e) => setUrls(e.target.value)}
          multiline
          rows={8}
          placeholder="https://example.com/image1.jpg, https://example.com/image2.jpg"
          sx={{ mb: 2 }}
        />
        <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
          💡 <strong>Lưu ý:</strong> Các link cách nhau bằng dấu phẩy (<strong style={{ color: "#EC6A52" }}>,</strong>)
        </Typography>
        <Button 
          variant="contained" 
          onClick={() => handleClick()} 
          size="large"
          fullWidth
          sx={{ py: 1.5 }}
        >
          Convert Images
        </Button>
      </Paper>
    
      {data.length > 0 && (
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1976d2' }}>
            Kết quả đã convert
          </Typography>
          <Card sx={{ mb: 2, backgroundColor: '#f8f9fa' }}>
            <CardContent>
              <Typography 
                variant="body2" 
                sx={{ 
                  fontFamily: 'monospace', 
                  fontSize: '0.875rem',
                  wordBreak: 'break-all',
                  whiteSpace: 'pre-wrap'
                }}
              >
                {data.join(",")}
              </Typography>
            </CardContent>
          </Card>
          <CopyButton text={data.join(",")} />
        </Paper>
      )}
    </Box>
  );
}
export default Option2